import styled from "styled-components";
import {useEffect, useMemo, useState} from "react";
import {API} from "../API/api";
import useGlobalSettings from "../Provider/useGlobalSettings";
import {ViewTypes} from "../Provider/useGlobalSettingsContextProvider";
import {VerseGuideSystem} from "./VerseGuideSystem";
import {useNavigate} from "react-router-dom";

const Styles = {
    Frame: styled.div`
        position: relative;
        padding-top: 20px;
    `,
    Image: {
        Frame: styled.div`
            position: relative;
        `,
        Image: styled.img`
            width: 100%;
            //filter: saturate(0.4) brightness(.9);
            opacity: 0.8;
            z-index: -1;
        `,
        Name: styled.div`
            position: absolute;
            height: inherit;
            display: flex;
            justify-content: center;
            align-self: center;
            top: calc(50% - 50px);
            font-size: 50px;
            font-weight: bold;
            z-index: 10;
            width: 100%;
            filter: drop-shadow(4px 4px 10px rgba(0,0,0,0.5));
        `
    },
    Caption: styled.div`
        padding: 10px;
        background-color: rgba(0,0,0,0.5);
    `,
    back: styled.div`
        text-decoration: underline;
        font-weight: bold;
    `
}

interface iSystems {
    id: string;
    image: string;
    description: string;
}
interface iSystem {
    id: string;
    image: string;
    description: string;
}

export const VerseGuide = () => {

    const navigate = useNavigate();
    const [systems, setSystems] = useState<iSystems[]>([]);
    const [focusSystemID, setFocusSystemID] = useState<string|undefined>();
    const [system, setSystem] = useState<iSystem[]>([]);

    useEffect(() => {
        API.getVerseGuide.systems()
            .then( response => {
                setSystems( response.data )
            })
    }, []);

    const handles = {
        onClick: (id: string) => {
            setFocusSystemID( id )
            void navigate( `/verse-guide/${id}` )
        },
        clear: () => setFocusSystemID( undefined )
    }


    return <Styles.Frame>
        { focusSystemID && <Styles.back onClick={ handles.clear } >Zurück</Styles.back> }
        { systems
            .filter( system => ! focusSystemID || system.id === focusSystemID )
            .map( system =>
            <Styles.Image.Frame onClick={ () => handles.onClick( system.id ) }>
                <Styles.Image.Name>{ system.id }</Styles.Image.Name>
                <Styles.Image.Image src={ system.image } />
            </Styles.Image.Frame>
            )
        }
    </Styles.Frame>;
};